<template>
  <VConfirmation
    v-model="actionModel"
    :confirm-button-label="texts.orderCancellationConfirmButtonLabel"
    :abort-button-label="texts.orderCancellationAbortButtonLabel"
    :swap-highlighting="orderCancellationAbortButtonLabelImportant"
    :confirm-attrs="{ 'aria-describedby': 'confirmHint' }"
    :heading="actionHeadline"
    class="row"
    v-bind="$attrs"
    @confirm="onConfirm"
    @expand="onExpand"
    @abort="$emit('abort')"
  >
    <template #prompt>
      <span v-html="promptText"></span>
    </template>
    <template v-if="showDatePicker" #beforeContent>
      <div class="form-input-set">
        <label>
          <span class="form-label">{{ $t('substore.requested_cancellation_date_label') }}</span>
          <div class="row offset-bottom-1 offset-top-1">
            <div class="offset-l-4 offset-m-3 col-l-4 col-m-6 col-s-12">
              <VDatepicker
                v-model="requestedCancellationDate"
                :disabled-date="disabledDate"
                :shortcuts="[{ text: $t('substore.requested_cancellation_date_reset'), onClick: () => earliestCancellationDate }]"
              />
            </div>
          </div>
        </label>
      </div>
      <p class="offset-bottom-1">{{ $t('substore.requested_cancellation_date_infotext', { date: earliestCancellationDateFormatted }) }}</p>
      <span id="confirmHint" class="sr-only">{{ $t('substore.requested_cancellation_date_hint') }}</span>
    </template>
  </VConfirmation>
</template>

<script>
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import subDays from 'date-fns/subDays';
import VConfirmation from '@/components/Confirmation';
import VDatepicker from '@/components/Form/DatePicker';
import { dateInputFormat } from '@/utils/date';

export default {
  name: 'StockProductButtonConfirmationCancel',

  components: {
    VConfirmation,
    VDatepicker,
  },

  inheritAttrs: false,

  props: {
    action: {
      type: Object,
      required: false,
      default: null,
    },

    texts: {
      type: Object,
      required: true,
    },

    orderCancellationAbortButtonLabelImportant: {
      type: Boolean,
      required: false,
    },

    productOption: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      earliestCancellationDate: null,
      requestedCancellationDate: null,
      minDate: new Date(),
    };
  },

  computed: {
    actionModel: {
      get() {
        return this.action;
      },
      set(v) {
        this.$emit('update:action', v);
      },
    },

    actionHeadline() {
      return this.actionModel?.headline;
    },

    promptText() {
      return this.texts.orderCancellationQuestion || this.$t('substore.prompt_cancel');
    },

    earliestCancellationDateFormatted() {
      return format(this.earliestCancellationDate, this.$t('common.dateFormat'));
    },

    showDatePicker() {
      return this.productOption?.plannedCancelAllowed;
    },
  },

  methods: {
    disabledDate(date) {
      return this.minDate.getTime() >= date.getTime();
    },

    onExpand() {
      if (this.showDatePicker) {
        this.earliestCancellationDate = parse(this.productOption.earliestCancellationDate, dateInputFormat, new Date());
        this.requestedCancellationDate = this.earliestCancellationDate;
        this.minDate = subDays(this.earliestCancellationDate, 1);
      }
      this.$emit('expand');
    },

    onConfirm(params) {
      const additionalParams = this.showDatePicker ? { date: format(this.requestedCancellationDate, dateInputFormat) } : {};
      this.$emit('confirm', params, additionalParams);
    },
  },
};
</script>
